<template>
  <div class="container-fluid px-4 px-xl-5">
    <SummaryBand />

    <div class="m-section dashboard-tabs">
      <tabs :fill="false" circle v-model="activeTab" @update="onTabChange">
        <tab-pane :title="DAILY_MENU_TAB">
          <span slot="title" class="nav-link-icon d-block">{{ DAILY_MENU_TAB }}</span>

          <Period v-if="getStatistics !== null" />
          <vue-content-loading
            v-else
            :width="300"
            :height="80"
            primary="#bdc3c7"
            secondary="#95a5a6"
            class="mt-4"
          >
            <svg:rect x="0" y="0" rx="3" ry="3" width="80" height="8" />
            <svg:rect x="90" y="0" rx="3" ry="3" width="50" height="8" />

            <svg:rect x="0" y="17" rx="3" ry="3" width="65" height="55" />
            <svg:rect x="79" y="17" rx="3" ry="3" width="65" height="55" />
            <svg:rect x="157" y="17" rx="3" ry="3" width="65" height="55" />
            <svg:rect x="235" y="17" rx="3" ry="3" width="65" height="55" />
          </vue-content-loading>

          <Income v-if="getIncome !== null" />
          <vue-content-loading
            v-else
            :width="300"
            :height="85"
            primary="#bdc3c7"
            secondary="#95a5a6"
          >
            <svg:rect x="0" y="0" rx="3" ry="3" width="80" height="8" />
            <svg:rect x="90" y="0" rx="3" ry="3" width="50" height="8" />

            <svg:rect x="0" y="17" rx="3" ry="3" width="65" height="55" />
            <svg:rect x="79" y="17" rx="3" ry="3" width="65" height="55" />
            <svg:rect x="157" y="17" rx="3" ry="3" width="65" height="55" />
            <svg:rect x="235" y="17" rx="3" ry="3" width="65" height="55" />
          </vue-content-loading>

          <Progress />
        </tab-pane>

        <tab-pane v-if="isOnDemand" :title="ON_DEMAND_TAB">
          <span slot="title" class="nav-link-icon d-block">{{ ON_DEMAND_TAB }}</span>

          <div v-if="levelsFailed" class="m-card">
            <div class="m-card__header">
              <div class="title-c">No se pudo cargar tu nivel</div>
            </div>
            <div class="m-card__footer orange">
              <div>{{ LEVELS_ERROR }}</div>
            </div>
          </div>
          <OnDemandLevel v-else />

          <OnDemandActivity />

          <OnDemandProgress />
        </tab-pane>

        <tab-pane :title="AUDITS_TAB">
          <span slot="title" class="nav-link-icon d-block">{{ AUDITS_TAB }}</span>
          <AuditoriasPanel />
        </tab-pane>
      </tabs>
    </div>
  </div>
</template>
<script>
import { VueContentLoading } from "vue-content-loading";
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";
import Period from "@/components/Metrics/Period";
import Income from "@/components/Metrics/Income";
import Progress from "@/components/Metrics/Progress";
import OnDemandLevel from "@/components/Metrics/OnDemandLevel";
import OnDemandActivity from "@/components/Metrics/OnDemandActivity";
import OnDemandProgress from "@/components/Metrics/OnDemandProgress";
import SummaryBand from "@/components/Metrics/SummaryBand";
import AuditoriasPanel from "@/components/Metrics/AuditoriasPanel";
import { mapActions, mapGetters } from "vuex";

const FIRST_PAGE = 1;
const DAILY_MENU_TAB = "Menú Diario";
const ON_DEMAND_TAB = "On Demand";
const AUDITS_TAB = "Auditorías";
const LEVELS_ERROR =
  "No se pudo cargar tu nivel On Demand. Recargá la página para volver a intentarlo.";

export default {
  components: {
    Tabs,
    TabPane,
    Period,
    Income,
    Progress,
    OnDemandLevel,
    OnDemandActivity,
    OnDemandProgress,
    SummaryBand,
    AuditoriasPanel,
    VueContentLoading
  },
  data() {
    return {
      LEVELS_ERROR,
      DAILY_MENU_TAB,
      ON_DEMAND_TAB,
      AUDITS_TAB,
      levelsFailed: false,
      activeTab: DAILY_MENU_TAB
    };
  },
  async created() {
    await this.GET_METRIC();

    if (this.isOnDemand) {
      await this.loadLevels();
    }

    this.loadAudits();
  },
  computed: {
    ...mapGetters(["isOnDemand"]),
    ...mapGetters("metrics", ["getStatistics", "getIncome", "getProgress"])
  },
  methods: {
    ...mapActions("metrics", ["GET_METRIC", "GET_PROGRESS"]),
    ...mapActions("foodcourtLevels", ["GET_LEVELS"]),
    ...mapActions("auditorias", ["GET_AUDITS", "GET_INTERVENTIONS"]),
    async loadLevels() {
      try {
        this.levelsFailed = false;
        await this.GET_LEVELS(FIRST_PAGE);
      } catch (error) {
        this.levelsFailed = true;
        this.$notify({ type: "danger", message: LEVELS_ERROR });
      }
    },
    loadAudits() {
      this.GET_AUDITS();
      this.GET_INTERVENTIONS();
    },
    onTabChange(tab) {
      this.activeTab = tab.title;
    }
  }
};
</script>

<style lang="scss" scoped>
.dashboard-tabs {
  ::v-deep .nav-link {
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    color: #2d2d2d;
  }
}
</style>
